export default __webpack_public_path__ + "static/media/cart.efe57ae5.svg";